'use strict';

var log = require('../../../../log/Log').channel('SocketWrapper');

/* global AveoTcpSocket */ // from cordova-plugin-aveo-ssh-client

var connectTimeoutMs = 8000;

var SocketWrapper = function() {
    this.state = 'disconnected'; // disconnected, connecting, connected, disconnecting
    this.host = '';
    this.port = 0;
    this.connectTimeout = null;
    this.userConnectCallback = null;
    this.userConnectErrorCallback = null;
    this.userReceiveCallback = null;
    this.userConnectionLostCallback = null;
    this.socket = null;
    this.isSsh = false;
};

SocketWrapper.prototype.connectPlain = function(host, port, userConnectCallback,
    userConnectErrorCallback, userReceiveCallback) {
    this.connect('plain', host, port, null, null, userConnectCallback, userConnectErrorCallback,
        userReceiveCallback);
};

SocketWrapper.prototype.connectSsh = function(host, port, username, password,
    userConnectCallback, userConnectErrorCallback, userReceiveCallback) {
    this.connect('ssh', host, port, username, password, userConnectCallback,
        userConnectErrorCallback, userReceiveCallback);
};

SocketWrapper.prototype.connect = function(type, host, port, username, password,
    userConnectCallback, userConnectErrorCallback, userReceiveCallback) {
    this.isSsh = type === 'ssh';
    this.host = host;
    this.port = port;

    if (typeof username === 'undefined' || username === null) username = '';
    if (typeof password === 'undefined' || password === null) password = '';

    if (this.state !== 'disconnected') {
        log.error(this + ': connect: not disconnected');

        if (typeof userConnectErrorCallback === 'function') {
            userConnectErrorCallback('not disconnected');
        }

        return;
    }

    this.userConnectCallback = userConnectCallback;
    this.userConnectErrorCallback = userConnectErrorCallback;
    this.userReceiveCallback = userReceiveCallback;
    this.doDisconnect = false;

    log.info('connect: ' + this.host + ':' + this.port + (this.isSsh ? ' (ssh)' : ''));
    this.state = 'connecting';
    // Set a connect timeout that is longer than the plugin. This is just a
    // backup in case the plugin fails to timeout.
    this.connectTimeout = window.setTimeout(
        this.onConnectTimeoutExpired.bind(this), connectTimeoutMs + 2000);

    this.socket = new AveoTcpSocket();
    this.socket.onData = this.onData.bind(this);
    this.socket.onError = this.onError.bind(this);
    this.socket.onClose = this.onClose.bind(this);
    this.key = this.socket.open(type, host, port, username, password, connectTimeoutMs,
        this.onOpen.bind(this), this.onOpenError.bind(this));
    log.info(this + ': connecting...');
};

SocketWrapper.prototype.toString = function() {
    return '[' + this.key + '] ' + this.host + ':' + this.port;
};

SocketWrapper.prototype.onConnectTimeoutExpired = function() {
    this.state = 'disconnected';

    log.info(this + ': onConnectTimeoutExpired: connect failed due to timeout');

    if (typeof this.userConnectErrorCallback === 'function') {
        this.userConnectErrorCallback('connect failed due to timeout');
    }

    this.state = 'connected'; // fake out so disconnect will work
    this.disconnect();
};

SocketWrapper.prototype.onOpen = function() {
    log.info(this + ': onOpen: connected');

    window.clearTimeout(this.connectTimeout);

    this.state = 'connected';

    if (this.doDisconnect) {
        log.info(this + ': onOpen: handling deferred disconnect');
        this.doDisconnect = false;
        this.disconnect();
        return;
    }

    if (typeof this.userConnectCallback === 'function') {
        this.userConnectCallback();
    }
};

SocketWrapper.prototype.onOpenError = function(message) {
    log.info(this + ': onOpenError: error opening socket: ' + message);

    window.clearTimeout(this.connectTimeout);

    this.state = 'disconnected';

    if (typeof this.userConnectErrorCallback === 'function') {
        this.userConnectErrorCallback(message);
    }
};

SocketWrapper.prototype.disconnect = function() {
    if (this.state === 'connecting') {
        this.doDisconnect = true;
        log.info(this + ': disconnect: deferring disconnect');
        return true;
    } else if (this.state !== 'connected') {
        log.error(this + ': disconnect: not connected');
        return false;
    }

    this.state = 'disconnecting';
    log.info(this + ': disconnect: disconnecting');

    if (this.socket === null) {
        log.warning(this + ': disconnect: socket is null');
        window.setTimeout((function() { this.onCloseError('socket is null'); }).bind(this), 1);
        return true;
    }

    // The onSuccess callback from the close method does not mean that the
    // socket is closed, only that the request has been received. The onClose
    // callback is called when the socket is actually closed.

    this.socket.close((function() {
        log.debug(this + ': disconnect: close command sent');
    }).bind(this), this.onCloseError.bind(this));

    return true;
};

SocketWrapper.prototype.onCloseError = function(message) {
    log.warning(this + ': onCloseError: failed closing socket: ' + message);
    this.socket = null;

    if (this.state === 'disconnected') {
        log.error(this + ': onCloseError: already disconnected');
        return;
    }

    this.state = 'disconnected';
};

SocketWrapper.prototype.onClose = function(hasError) {
    this.socket = null;

    if (hasError) {
        log.info(this + ': onClose: closed due to error');
    } else {
        log.info(this + ': onClose: closed');
    }

    if (this.state === 'disconnected') {
        log.warning(this + ': onClose: already disconnected');
        return;
    }

    var prevState = this.state;

    this.state = 'disconnected';

    if (prevState === 'connected' &&
        typeof this.userConnectionLostCallback === 'function') {
        this.userConnectionLostCallback();
    }

};

SocketWrapper.prototype.onError = function(message) {
    log.warning(this + ': onError: error, disconnecting: ' + message);

    var prevState = this.state;

    this.state = 'disconnected';

    if (prevState === 'connected' &&
        typeof this.userConnectionLostCallback === 'function') {
        this.userConnectionLostCallback();
    }
};

SocketWrapper.prototype.send = function(data) {
    if (this.socket === null) {
        log.warning(this + ': send: socket is null');
        window.setTimeout((function() { this.onWriteError('socket is null'); }).bind(this), 1);
        return;
    }

    this.socket.write(data, this.onWrite.bind(this), this.onWriteError.bind(this));
};

SocketWrapper.prototype.onWrite = function() {
};

SocketWrapper.prototype.onWriteError = function(message) {
    log.warning(this + ': onWriteError: error sending data: ' + message);
};

SocketWrapper.prototype.onData = function(data) {
    if (typeof this.userReceiveCallback === 'function') {
        this.userReceiveCallback(data);
    }
};

SocketWrapper.prototype.setReceiveCallback = function(userReceiveCallback) {
    this.userReceiveCallback = userReceiveCallback;
};

SocketWrapper.prototype.setConnectionLostCallback = function(userConnectionLostCallback) {
    this.userConnectionLostCallback = userConnectionLostCallback;
};

module.exports = SocketWrapper;
